import './UnderConstructionPage.css';

import React from 'react';

import MarketingFooter
  from '../components/common/MarketingFooter/MarketingFooter';
import MarketingTopNav
  from '../components/common/MarketingTopNav/MarketingTopNav';
import PomPom from '../components/common/PomPom/PomPom';

const UnderConstructionPage: React.FC = () => (
  <div className="uc-container">
    <MarketingTopNav />

    <div className="uc-gutter-pompoms" aria-hidden="true">
      <PomPom size="small" color="pink" className="uc-gutter-pompom uc-gutter-pompom-left-top" />
      <PomPom size="xlarge" color="teal" className="uc-gutter-pompom uc-gutter-pompom-right-top" />
      <PomPom size="medium" color="pink" className="uc-gutter-pompom uc-gutter-pompom-left-mid" />
      <PomPom size="large" color="teal" className="uc-gutter-pompom uc-gutter-pompom-right-mid" />
      <PomPom size="small" color="teal" className="uc-gutter-pompom uc-gutter-pompom-left-bottom" />
      <PomPom size="medium" color="pink" className="uc-gutter-pompom uc-gutter-pompom-right-bottom" />
      <PomPom size="xlarge" color="pink" className="uc-gutter-pompom uc-gutter-pompom-wide-left-top" />
      <PomPom size="xlarge" color="teal" className="uc-gutter-pompom uc-gutter-pompom-wide-right-top" />
      <PomPom size="large" color="teal" className="uc-gutter-pompom uc-gutter-pompom-wide-left-bottom" />
      <PomPom size="large" color="pink" className="uc-gutter-pompom uc-gutter-pompom-wide-right-bottom" />
    </div>

    <div className="uc-maxwidth-container">
      <section className="uc-hero">
        <PomPom size="large" color="pink" className="uc-hero-pompom uc-hero-pompom-top" />
        <PomPom size="medium" color="teal" className="uc-hero-pompom uc-hero-pompom-bottom" />

        {/* <div className="uc-hero-badge">Pardon our dust</div> */}

        <h1 className="uc-hero-title">
          Under<br />
          <span className="uc-hero-accent">Construction</span>
        </h1>

        <p className="uc-hero-subtitle">
          We're choreographing this part of the routine. Check back soon!
        </p>
      </section>

      <div className="uc-pyramid-wrap">
        <img
          src="/images/construction/cheer_pyramid.svg"
          alt="Cheerleading pyramid"
          className="uc-pyramid"
        />
      </div>

      <MarketingFooter />
    </div>
  </div>
);

export default UnderConstructionPage;
